import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from 'ag-grid-enterprise';
import '@angular/compiler';
import { AG_GRID_LICENSE } from 'ag-grid-license';
import { datadogEnv } from '@aptitude/shared';
import '@aptitude/front-end-components';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
LicenseManager.setLicenseKey(AG_GRID_LICENSE);

const env = datadogEnv(window.location.host);

// clientToken and site have all been updated for Datadog US1.
datadogLogs.init({
  clientToken: 'pub873442ffb946d9bb38206fcf1833e4b5',
  env,
  site: 'datadoghq.com',
  forwardConsoleLogs: 'all',
  forwardErrorsToLogs: true,
  forwardReports: 'all',
  service: 'aptitude',
  sessionSampleRate: 100,
});

// applicationId, clientToken, and site have all been updated for Datadog US1.
datadogRum.init({
  allowedTracingUrls: [
    /(https:\/\/[\w-]+\.aptitudedev\.com|localhost:\w+|https:\/\/[\w-]*.aptitudemarketplace\.com)(?!.*\/download.*)/i,
  ],
  applicationId: 'b8bc0253-22e5-4560-9ff2-ca378ee3bef7',
  clientToken: 'pub873442ffb946d9bb38206fcf1833e4b5',
  enableExperimentalFeatures: ['clickmap', 'feature_flags'],
  site: 'datadoghq.com',
  service: 'aptitude-platform',
  env: window.location.host,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  telemetrySampleRate: 100, // I think this has to do with errors related to DD itself, not our app: https://docs.datadoghq.com/real_user_monitoring/browser/
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  trackFrustrations: true,
  traceSampleRate: 100,
  defaultPrivacyLevel: 'mask-user-input',
});

datadogRum.startSessionReplayRecording();
